{
  "name": "dungeoneer",
  "version": "3.1.0",
  "description": "A procedural dungeon generator",
  "main": "dist/index.js",
  "types": "./dist/index.d.ts",
  "homepage": "https://github.com/LucianBuzzo/dungeoneer",
  "repository": {
    "type": "git",
    "url": "git://github.com/LucianBuzzo/dungeoneer.git"
  },
  "scripts": {
    "build": "tsc -p tsconfig.json",
    "pretest": "npm run build",
    "predev": "npm run build",
    "prebuild:demo": "npm run build",
    "test": "nyc --reporter=lcov ava -v",
    "lint": "standard 'test/**/*.js' 'demo/main.js'",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "ci": "npm run lint && npm run typecheck && npm run test",
    "dev": "parcel ./demo/index.html",
    "build:demo": "parcel build --public-url ./ ./demo/index.html",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "procedural",
    "map",
    "generator",
    "dungeon",
    "games",
    "level",
    "roguelike"
  ],
  "author": "Lucian Buzzo <lucian.buzzo@gmail.com>",
  "license": "MIT",
  "engines": {
    "node": ">=20"
  },
  "dependencies": {
    "chance": "^1.0.18",
    "underscore": "^1.8.3",
    "victor": "^1.1.0"
  },
  "devDependencies": {
    "@types/chance": "^1.1.7",
    "@types/node": "^22.13.10",
    "@types/underscore": "^1.11.15",
    "@types/victor": "^1.1.5",
    "ava": "^3.15.0",
    "nyc": "^15.1.0",
    "parcel": "^2.0.1",
    "standard": "^16.0.4",
    "typescript": "^5.8.2"
  },
  "ava": {
    "files": [
      "test/**/*.spec.js"
    ]
  },
  "browserslist": [
    "last 2 Chrome versions"
  ],
  "targets": {
    "module": false,
    "main": false,
    "types": false
  }
}
